import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';
import customAnalytics from './util/custom-analytics';
import environment from './env-config.js'
import LocalImpersonationStopButton from './components/LocalImpersonationStopButton';
import GlobalAnnouncementBanner from './components/GlobalAnnouncementBanner';

class App extends Component {
    trackUmamiPageview = (url, attempt = 0) => {
        const umami = window.umami;
        if (umami && typeof umami.track === 'function') {
            umami.track(props => ({
                ...props,
                title: document.title,
                url
            }));
            return;
        }

        if (attempt < 10) {
            window.setTimeout(() => this.trackUmamiPageview(url, attempt + 1), 300);
        }
    };

    trackCurrentPage = () => {
        if (environment.REACT_NODE_ENV !== 'production') {
            return;
        }

        const path = window.location.pathname;
        const isLoggedIn = Boolean(localStorage.getItem('token'));
        const isExcludedAnalyticsRoute =
            path.startsWith('/f/') ||
            path === '/solucky' ||
            path.startsWith('/solucky/');

        const url = path + window.location.search + window.location.hash;

        if (isExcludedAnalyticsRoute) {
            // In-app routes remain inside product analytics and are never
            // sent to Umami's anonymous marketing measurement.
            if (isLoggedIn) {
                customAnalytics.app_pageview(url, 'AppScreen');
            }
            return;
        }

        if (isLoggedIn) {
            customAnalytics.pageview(url, url);
        } else {
            this.trackUmamiPageview(url);
        }
    };

    componentDidMount() {
        this.trackCurrentPage();

        this.unlisten = this.props.history.listen(() => {
            this.trackCurrentPage();
        });
    }
    componentWillUnmount() {
        if (this.unlisten) {
            this.unlisten();
        }
    }
    render() {
        const isLoggedIn = typeof window !== 'undefined' && Boolean(localStorage.getItem('token'));
        return (
            <AppContainerShell>
                <LocalImpersonationStopButton />
                <GlobalAnnouncementBanner isLoggedIn={isLoggedIn} />
                <AppRouteContent>
                    {this.props.children}
                </AppRouteContent>
            </AppContainerShell>
        );
    }
}

const AppContainerShell = styled.div`
    display: flex;
    flex-direction: column;
    min-height: 100vh;
`;

const AppRouteContent = styled.div`
    flex: 1 1 auto;
    min-height: 0;
`;

export default withRouter(App);
